import type { CatalogItem, CatalogResponse } from "../types";

export const seedProduct: CatalogItem = {
  id: "1start00525",
  title:
    "新卒で入った会社の研修がしんどくて息抜きにピンサロ行ったらめちゃ怖いOJT女上司と遭遇「副業バラされたくなければ…」とカマかけたら見事本番OK 以来会社でも自宅でも生ハメしまくり最高にハッピー 青空ひかり",
  performers: ["青空ひかり"],
  maker: "SODクリエイト",
  genres: [
    { id: "all", name: "すべて" },
    { id: "ol", name: "OL" },
    { id: "solo", name: "単体作品" },
    { id: "4k", name: "4K" },
    { id: "amateur", name: "素人" },
  ],
  releaseDate: "2026-04-09",
  price: {
    display: "¥1,340〜",
    fetchedAt: "2026-08-18T00:00:00+09:00",
  },
  images: {
    shelf:
      "https://pics.dmm.co.jp/digital/video/1start00525/1start00525pt.jpg",
    shelfHigh:
      "https://pics.dmm.co.jp/digital/video/1start00525/1start00525ps.jpg",
    detail:
      "https://pics.dmm.co.jp/digital/video/1start00525/1start00525pl.jpg",
    samples: [
      "https://pics.dmm.co.jp/digital/video/1start00525/1start00525jp-1.jpg",
      "https://pics.dmm.co.jp/digital/video/1start00525/1start00525jp-2.jpg",
      "https://pics.dmm.co.jp/digital/video/1start00525/1start00525jp-3.jpg",
    ],
  },
  affiliateUrl:
    "https://video.dmm.co.jp/av/content/?id=1start00525&i3_ref=ranking&i3_ord=1&i3_pst=2&dmmref=bestseller_ranking_2d_digital_top&via=digital_top",
  source: "seed",
};

export const seedCatalog: CatalogResponse = {
  items: [seedProduct],
  fetchedAt: seedProduct.price.fetchedAt,
  source: "seed",
  warning: "DMM API is not connected. The requested reference product is in use.",
};
